export const FRETS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];

export const NOTES = ["a", "a#", "b", "c", "c#", "d", "d#", "e", "f", "f#", "g", "g#"];

export const STRING_FRET_NOTES = [
    [],
    ["e", "f", "f#", "g", "g#", "a", "a#", "b", "c", "c#", "d", "d#", "e", "f"],
    ["b", "c", "c#", "d", "d#", "e", "f", "f#", "g", "g#", "a", "a#", "b", "c"],
    ["g", "g#", "a", "a#", "b", "c", "c#", "d", "d#", "e", "f", "f#", "g", "g#"],
    ["d", "d#", "e", "f", "f#", "g", "g#", "a", "a#", "b", "c", "c#", "d", "d#"],
    ["a", "a#", "b", "c", "c#", "d", "d#", "e", "f", "f#", "g", "g#", "a", "a#"],
    ["e", "f", "f#", "g", "g#", "a", "a#", "b", "c", "c#", "d", "d#", "e", "f"],
];

export const STRING_FRET_POSITIONS = [
    [],
    [
        [-5, -5],
        [-5, 34],
        [-5, 102],
        [-5, 165],
        [-5, 225],
        [-5, 281],
        [-6, 337],
        [-6, 386],
        [-6, 433],
        [-6, 477],
        [-7, 520],
        [-7, 561],
        [-7, 600],
        [-7, 635],
    ],
    [
        [13, -5],
        [13, 34],
        [13, 102],
        [13, 165],
        [13, 225],
        [13, 281],
        [12, 337],
        [12, 386],
        [12, 433],
        [12, 477],
        [11, 520],
        [11, 561],
        [11, 600],
        [11, 635],
    ],
    [
        [31, -5],
        [31, 34],
        [31, 102],
        [31, 165],
        [31, 225],
        [31, 281],
        [31, 337],
        [31, 386],
        [31, 433],
        [31, 477],
        [31, 520],
        [31, 561],
        [31, 600],
        [31, 635],
    ],
    [
        [50, -5],
        [50, 34],
        [50, 102],
        [50, 165],
        [50, 225],
        [50, 281],
        [51, 337],
        [51, 386],
        [51, 433],
        [51, 477],
        [51, 520],
        [51, 561],
        [51, 600],
        [51, 635],
    ],
    [
        [69, -5],
        [69, 34],
        [69, 102],
        [69, 165],
        [69, 225],
        [69, 281],
        [70, 337],
        [70, 386],
        [70, 433],
        [70, 477],
        [70, 520],
        [71, 561],
        [71, 600],
        [71, 635],
    ],
    [
        [87, -5],
        [87, 34],
        [87, 102],
        [87, 165],
        [87, 225],
        [87, 281],
        [88, 337],
        [88, 386],
        [88, 433],
        [88, 477],
        [89, 520],
        [89, 561],
        [89, 600],
        [89, 635],
    ],
];
